<template>
  <div class="pre-leilao">
    <!-- Titulo Box -->
    <v-container
      class="mt-6 mb-6"
      fluid
    >
      <v-row>
        <v-col class="fill-height">
          <Slider
            :assets="lot.assets"
          ></Slider>
          <v-skeleton-loader
            width="100%"
            height="100%"
            type="image"
          ></v-skeleton-loader>
        </v-col>
        <Bids
          :countdown-is-pre="false"
        />
        <NextLots />
      </v-row>
    </v-container>
  </div>
</template>
<script>
import RegisterMixin from '@/mixins/RegisterMixin';
import Slider from '@/views/leilao/components/Slider';
import Bids from '@/views/leilao/components/Bids';
import NextLots from '@/views/leilao/components/NextLots';

export default {
  name: 'Home',
  components: {
    Slider,
    Bids,
    NextLots,
  },
  mixins: [RegisterMixin],
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      icons: ['mdi-facebook', 'mdi-twitter', 'mdi-linkedin', 'mdi-instagram'],
    };
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
    userData() {
      return this.$store.state.Data.User.profile;
    },
  },
  created() {
    // UserService.retriverProfileInfo();
    this.$bus.on(this.$events.GET_PARTNER, () => {
      // UserService.retriverProfileInfo();
    });
  },
  methods: {
    prevLote() {
      this.$route.params.lote--;
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO_LOTE.NAME,
        params: {
          lote: this.$route.params.lote,
        },
      });
    },
    nextLote() {
      this.$route.params.lote++;
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO_LOTE.NAME,
        params: {
          lote: this.$route.params.lote,
        },
      });
    },
    startCallBack() {},
    endCallBack() {},
    logOut() {
      this.$router.push({ name: this.$consts.ROUTES.AUTH_LOGIN.NAME });
    },
  },
};
</script>
<style lang="scss">
@import "@/static/css/Variables.scss";
.pre-leilao {
  @media (max-width: $md) {
    .container {
      .row {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
